// SPDX-FileCopyrightText: 2026 Z-Meet contributors
// SPDX-License-Identifier: Apache-2.0

/**
 * Thứ bậc vai trò trong phòng họp.
 *
 * Bản sao của `store.Role.rank()` ở phía server, và một bản sao thì luôn có
 * nguy cơ lệch — nên nói rõ nó dùng để làm gì và KHÔNG dùng để làm gì.
 *
 * Nó KHÔNG cưỡng chế gì cả. Cưỡng chế nằm ở `internal/meeting/moderate.go`,
 * đi qua `authz.CanActOnParticipant`, và mọi thao tác điều hành đều phải qua
 * đó dù giao diện có vẽ nút hay không (cùng lập luận với phòng chờ, ADR-0002
 * bất biến 2). Chỗ này chỉ trả lời một câu hỏi hẹp hơn nhiều: **có nên vẽ cái
 * nút ấy ra không**.
 *
 * Câu hỏi ấy đáng được trả lời đúng vì một menu dẫn thẳng tới 403 tệ hơn một
 * menu vắng mặt: người bấm không biết mình vừa làm sai cái gì, và không có
 * cách nào để làm cho đúng.
 */
const MEETING_RANK: Record<string, number> = {
  host: 3,
  cohost: 2,
  presenter: 1,
  attendee: 0,
}

/**
 * rank quy một chuỗi vai trò về một bậc.
 *
 * Vai trò lạ rơi về 0 chứ không phải -1, và đó là bản sao trung thực của
 * `default: return 0` ở phía server — nhưng nó cũng là hướng hỏng ĐÚNG cho
 * một quyết định về giao diện: server thêm một vai trò mới mà client chưa
 * biết thì host vẫn thấy menu và server vẫn là bên quyết định. Hướng ngược
 * lại giấu mất một khả năng có thật, và không ai đọc được lý do vì sao.
 */
function rank(role: string): number {
  return MEETING_RANK[role] ?? 0
}

/**
 * outranks trả lời "người này có tác động được lên người kia không".
 *
 * LỚN HƠN HẲN, không phải lớn hơn hoặc bằng — đây chính là chỗ mà một dấu `>=`
 * viết nhầm sẽ vẽ ra menu điều hành trên ô video của một host khác, và mọi nút
 * trong đó trả 403 (ADR-0002 bất biến 10: cohost không tác động được lên host,
 * và không ai tác động được lên người ngang hàng).
 */
export function outranks(actor: string, target: string): boolean {
  return rank(actor) > rank(target)
}
